exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".rollback-upload-dialog .rollback-upload-row[data-v-695f0f9e]{margin:0 0 20px}.rollback-upload-dialog .rollback-upload-row.submit-panel[data-v-695f0f9e]{text-align:center;margin:30px 0 0}", "", {"version":3,"sources":["/workspace/src/views/finance/pages/BankWithdrawTable.vue"],"names":[],"mappings":"AACA,8DAA8D,eAAe,CAC5E,AACD,2EAA2E,kBAAkB,eAAe,CAC3G","file":"BankWithdrawTable.vue","sourcesContent":["\n.rollback-upload-dialog .rollback-upload-row[data-v-695f0f9e]{margin:0 0 20px\n}\n.rollback-upload-dialog .rollback-upload-row.submit-panel[data-v-695f0f9e]{text-align:center;margin:30px 0 0\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-695f0f9e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/finance/pages/BankWithdrawTable.vue
// module id = 4044
// module chunks = 33